document.addEventListener("DOMContentLoaded", function () {
  const brandTabs = document.querySelectorAll(".header-brand-tab");
  const sparkle = document.querySelector(".page-sparkle");
  // document.body.style.opacity = "1";
  brandTabs.forEach(tab => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      const url = this.href;
      // document.body.style.opacity = "0.3";
      sparkle.style.left = "140%";
      setTimeout(() => {
        window.location.href = url;
      }, 300);
    });
  });
});